import React from "react";
//import FooterLogo from "../../assets/FooterLogo.svg"
import FooterLogo from "../../assets/AmitaSoftF.svg"
import {
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Link } from "react-router-dom";
import FooterIconFb from "../../assets/FooterIconFB.png";
import FooterIconX from "../../assets/FooterIconX.svg";
import FooterIconInsta from "../../assets/FooterIconInsta.png";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  footerBGS: {
    backgroundColor: "#373973",
    color: "white",
    // backgroundImage: "url('/images/footerBg.png')",
    // backgroundRepeat: "no-repeat",
    // backgroundSize: "10%",
    // backgroundPosition: "left 15% bottom",
  },

});

function Footer() {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const aboutUrl = process.env.REACT_APP_ABOUT_US_URL || "https://qa.dev.cliqloan.com/#about";

  return (
    <>
      <Box >
        <Container className={classes.footerBGS} maxWidth="100%">
          <Grid container>
            <Grid
              item
              container
              xs={12}
              px={{ xs: 2 }}
              my={{ xs: 5, md: 15 }}

            >
              <Grid item md={6} xs={12}>
                <Box display="flex" alignItems="left" paddingLeft={0} marginLeft={isSmallScreen ? 0 : 8}>
                  <a href="/" style={{ textDecoration: "none" }}>
                    <img src={FooterLogo} className="footerlogo" alt="FooterLogo" height={24} width={117} />
                  </a>
                </Box>

              </Grid>
              <Grid item md={2} sm={12} xs={12} my={{ xs: 1 }}>

              </Grid>
              <Grid item md={2} sm={12} xs={12} my={{ xs: 1 }}>
                <Box>
                  <a href={aboutUrl} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#FFFFFF" }}>
                    <Typography
                      variant="body2"
                      fontWeight={"bold"}
                      fontFamily={"inter"}
                    >
                      About us
                    </Typography>
                  </a>
                </Box>
              </Grid>
              <Grid item md={2} sm={12} xs={12} my={{ xs: 1 }}>
                <Box>
                  {<Typography
                    variant="body2"
                    fontWeight={"bold"}
                    fontFamily={"inter"}
                  >
                    Connect with us
                  </Typography>}
                  <Stack direction={"row"} spacing={1} mt={1}>
                    <Link to="/facebook" style={{ textDecoration: 'none' }}>
                      <IconButton onClick={() => window.open("https://www.facebook.com/profile.php?id=61583589355202", "_blank")}>
                        <img src={FooterIconFb} alt="Facebook" />
                      </IconButton>
                    </Link>

                    <Link to="/x" style={{ textDecoration: 'none' }}>
                      <IconButton aria-label="X.com" onClick={() => window.open("https://x.com/amitasoft358151", "_blank")}>
                        <img src={FooterIconX} alt="X" />
                      </IconButton>
                    </Link>

                    <Link to="/instagram" style={{ textDecoration: 'none' }}>
                      <IconButton onClick={() => window.open("https://www.instagram.com/amitasoft/", "_blank")}>
                        <img src={FooterIconInsta} alt="Instagram" />
                      </IconButton>
                    </Link>
                  </Stack>
                </Box>
              </Grid>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Divider sx={{ backgroundColor: "white" }} />
            </Grid>

            <Grid item container xs={12} md={12} my={6} mx={2}>
              <Grid item md={2} sm={2} xs={12} my={{ xs: 1, md: "none" }}>
                <Link to="/support/disclaimer" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
                  <Typography variant="body2" marginLeft={isSmallScreen ? 2 : 8}>Disclaimers</Typography>
                </Link>
              </Grid>
              <Grid item md={2} sm={2} xs={12} my={{ xs: 1, md: "none" }}>
                <Link to="/support/terms-of-use" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>

                  <Typography variant="body2" marginLeft={isSmallScreen ? 2 : 8}>Terms of Use</Typography>
                </Link>
              </Grid>

              <Grid item md={2} sm={2} xs={12} my={{ xs: 1, md: "none" }}>
                <Link to="/support/privacy-policy" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
                  <Typography variant="body2" marginLeft={isSmallScreen ? 2 : 8}>Privacy Policy</Typography>
                </Link>
              </Grid>

              <Grid item md={2} sm={2} xs={12} my={{ xs: 1, md: "none" }}>
                <Link to="/support/california-policy" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
                  <Typography variant="body2" marginLeft={isSmallScreen ? 2 : 8}>California Policy</Typography>
                </Link>
              </Grid>
              <Grid item md={1} sm={2} xs={12} my={{ xs: 1, md: "none" }}>
                <Link to="/support/security-policy" style={{ textDecoration: "none", color: "#FFFFFF" }} onClick={() => window.scrollTo(0, 0)}>
                  <Typography variant="body2" marginLeft={isSmallScreen ? 2 : 8}>Security</Typography>
                </Link>
              </Grid>

            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default Footer;
